module.exports = __webpack_public_path__ + "6b089bd6180a69c1744a7f184065ea85.png";